"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ui_1 = require("@ocean-club/ui");
const utils_1 = require("../../modules/translation/utils");
const connect_1 = require("@ocean-club/connect");
const { TRONLINK, } = ui_1.LoginModalOptionType;
class LoginModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleOnConnect = () => {
            this.props.onConnect(connect_1.ProviderType.INJECTED);
        };
        this.getModalTranslations = () => {
            if (!this.props.hasTranslations) {
                return undefined;
            }
            return {
                title: React.createElement(utils_1.T, { id: "@dapps.login.modal.title" }),
                subtitle: React.createElement(utils_1.T, { id: "@dapps.login.modal.subtitle" }),
                error: React.createElement(utils_1.T, { id: "@dapps.login.modal.error" })
            };
        };
        this.getOptionTranslations = () => {
            if (!this.props.hasTranslations) {
                return undefined;
            }
            return {
                browser_extension: React.createElement(utils_1.T, { id: "@dapps.login.option.browser_extension" }),
                klever: React.createElement(utils_1.T, { id: "@dapps.login.option.klever" }),
                mobile: React.createElement(utils_1.T, { id: "@dapps.login.option.mobile" })
            };
        };
        this.renderLoginModalOption = () => {
            let loginType = TRONLINK;
            return loginType ? (React.createElement(ui_1.LoginModal.Option, { key: loginType, type: loginType, i18n: this.getOptionTranslations(), onClick: () => this.handleOnConnect() })) : null;
        };
        this.state = {
            hasError: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.hasError && this.props.hasError) {
            this.setState({
                hasError: true
            });
        }
        else if (prevProps.hasError && !this.props.hasError) {
            this.setState({
                hasError: false
            });
        }
    }
    render() {
        const { open, className, isLoading, onClose } = this.props;
        const { hasError } = this.state;
        return (React.createElement(ui_1.LoginModal, { open: open, className: className, i18n: this.getModalTranslations(), loading: isLoading, hasError: hasError, onClose: onClose }, this.renderLoginModalOption()));
    }
}
exports.default = LoginModal;
LoginModal.defaultProps = {
    isLoading: false
};
//# sourceMappingURL=LoginModal.js.map